import React, { useMemo, useState } from 'react';
import { SelectableColumn } from '../SelectableColumn';
import { createColumnRecord } from '../utils/createColumnRecord';
import { createHeaders } from '../utils/createHeaders';
import { ViewContext } from './ViewContext';
import { useLocalization } from 'localization/useLocalization';
import { createStatusRecord } from '../utils/createdStatusRecord';

// enkel hier nodig
const DefaultColumns: SelectableColumn[] = ['key', 'pos', 'backlog'];

export const ViewProvider = ({ children }: any) => {
	const strings = useLocalization();
	const [columns, setColumns] = useState<SelectableColumn[]>(DefaultColumns);
	const colRecord = useMemo(() => createColumnRecord(strings), [strings]);
	const headers = useMemo(() => createHeaders(colRecord), [colRecord]);
	const statusRecord = useMemo(() => createStatusRecord(strings), [strings]);

	return (
		<ViewContext.Provider
			value={{
				columns: columns,
				columnsRecord: colRecord,
				headers: headers,
				setColumns: setColumns,
				statusRecord: statusRecord,
			}}>
			{children}
		</ViewContext.Provider>
	);
};
